import { useTranslation } from 'next-i18next';
import { useRef } from 'react';
import { useReactToPrint } from 'react-to-print';

import { PrintContent, PrintHeader } from '@/modules/settings/property';
import { IPropertySettings } from '@/modules/settings/property/types';
import { Button, NextImage } from '@/shared/components/atoms';
import { useModal } from '@/shared/hooks/context/modalContext/useModal';

import FieldQr from '~/images/shared/fieldQr.jpeg';

const PrintFieldQr: React.FC<{
  field: IPropertySettings.IPropertyField;
  successVariant?: boolean;
}> = ({ field, successVariant }) => {
  const { t } = useTranslation();

  const { closeModal } = useModal();

  const QRCodesRef = useRef(null);

  const handlePrint = useReactToPrint({
    content: () => QRCodesRef.current,
    fonts: [{ family: 'Cairo', source: '' }],
  });

  return (
    <div className='flex flex-col gap-32'>
      <PrintHeader successVariant={successVariant ?? false} />
      <div className='grid min-w-[464px] grid-cols-2 gap-24'>
        <PrintContent ref={QRCodesRef} field={field} />
        <NextImage
          src={FieldQr}
          fill
          alt='Qr code field'
          imgClassName='rounded-xl object-cover'
        />
      </div>
      <div className='flex gap-24'>
        <Button
          variant='text'
          size='none'
          className='h-56 w-full !rounded-xl border-xs border-outline-default'
          onClick={() => closeModal()}
        >
          {t('Dismiss')}
        </Button>
        <Button
          onClick={handlePrint}
          size='full'
          className='h-56 w-full !rounded-xl'
        >
          {t('Print QR Code')}
        </Button>
      </div>
    </div>
  );
};

export default PrintFieldQr;
